import {
  Patient,
  PatientSymptom,
  QualityOfLife,
  SymptomCalcInfo
} from 'lib/documents';
import { isQolExpired } from 'lib/utils/business';
import { getSources } from './getSources';
import { PatientInfoState } from './patient-info-slice-types';

// /**
//  *
//  * @param missingSymptomCalcInfo
//  * @param patient
//  * @deprecated
//  */
// export function recalculateMissingSubSymptoms(
//   missingSymptomCalcInfo: SymptomCalcInfo[],
//   _patient: Patient
// ) {
//   const missingSymptoms: string[] = [];
//   for (const symptom of missingSymptomCalcInfo) {
//     if (symptom.id) {
//       missingSymptoms.push(symptom.id.replace(/\s/g, ''));
//     }
//   }

//   // // WARNING: This Promise is not awaited. If the user navigates away from the page the HTTP request can be cancelled
//   // recalculateSubSymptoms({
//   //   patientId: `${patient.id}`,
//   //   symptoms: missingSymptoms,
//   //   subSymptoms: []
//   // }).catch(error => {
//   //   console.error('An error occurred calculating symptoms: ', error.message);
//   // });
// }

/**
 * TODO patient.inventoryExpirations is always undefined;
 * getSources needs to be updated(?) to include everything
 * should have a 30 day expiration
 *
 * @deprecated Calculation results are not used by the platform
 * @legacy Part of the legacy platform
 */
export function handleSubsymptomCalculation({
  symptomCalcInfoArr,
  symptoms,
  patient,
  state,
  qols
}: {
  symptomCalcInfoArr: SymptomCalcInfo[];
  symptoms: PatientSymptom[];
  patient: Patient;
  state: PatientInfoState;
  qols: QualityOfLife[];
}) {
  /**
   * 2025-06-06 Disable the Symptom and SubSymptom calculation because it is not used by the platform
   * https://trello.com/c/lnnj4vwW
   *
   * If this system is re-enabled it will need to be refactored and moved to the backend
   */
  return;
  const { missing, expired } = getSources(
    symptomCalcInfoArr,
    symptoms,
    patient.inventoryExpirations
  );

  // redo calculations of missingSymptomCalcInfo on load
  const missingSymptomCalcInfo = symptomCalcInfoArr.filter(
    calc => calc.status == 'fail'
  );

  const hasMissingSymptoms = missingSymptomCalcInfo.length > 0;
  if (hasMissingSymptoms) {
    // recalculateMissingSubSymptoms(missingSymptomCalcInfo, patient);
  }
  // end redo calculations of missingSymptomCalcInfo on load
  state.expiredSources = expired;
  state.missingSources = missing;

  state.symptomsExpired =
    (expired && Boolean(expired.length)) ||
    (missing && Boolean(missing.length));

  const nonExpiredQoLs = qols.filter(e => !isQolExpired(e.date));

  /**
   * TODO: qolExpired should be updated here for individual
   * qol expiration and not batch qol expiration
   * it's already done in the front end of the reducer so
   * we should update this and just read off the reducer
   * instead of calculating on the front end
   */
  state.qolExpired = !(
    nonExpiredQoLs.some(v => v.dailyLiving) &&
    nonExpiredQoLs.some(v => v.physicalActivity) &&
    nonExpiredQoLs.some(v => v.selfRating)
  );
}
